import classNames from 'classnames';
import styles from './info.module.scss';
import {useNavigate} from 'react-router-dom';

type TDashboardInfo = {
  commentCount: number;
  rate: number;
};

const DashboardInfo = ({commentCount, rate}: TDashboardInfo) => {
  const navigate = useNavigate();
  return (
    <>
      <div
        className={classNames(
          'd-flex justify-content-around align-items-center',
          styles['dashboard-info'],
        )}
      >
        <div className="p-3 py-4 bg-color-blue-2 w-50 text-center ms-3">
          <div>
            <span className="pe-1 color-gray-1">{rate}</span>
            <i className="icon-Star color-gold-custom"></i>
          </div>
          <div>
            <small className="color-gray-2">امتیاز</small>
          </div>
        </div>
        <div
          className="p-3 py-4 bg-color-gray-7 w-50 text-center"
          onClick={() => navigate('/shop/manage/comment')}
        >
          <div>
            <span className="color-gray-1">{commentCount} نفر</span>
          </div>
          <div>
            <small className="color-gray-2"> تعداد نظرات</small>
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardInfo;
